<template>
  <Transition name="fade">
    <div v-if="getToasterAlert.length" class="toaster-alert">
      <div
        v-for="(item, index) in getToasterAlert"
        :key="index"
        class="toaster-alert__item"
      >
        <UiAlert
          :type="item.type"
          :icon="item.icon"
          :text="item.text"
          :is-close="typeof item.isClose === 'boolean' ? item.isClose : true"
          @close="() => close(index)"
        />
      </div>
    </div>
  </Transition>
</template>
<script>

import { mapGetters, mapMutations } from 'vuex'

export default {
  name: 'NotifyToast',
  computed: {
    ...mapGetters('notifyToast', ['getToasterAlert']),
  },
  methods: {
    ...mapMutations('notifyToast', ['removeToasterAlertIndex']),
    close(index) {
      this.removeToasterAlertIndex(index)
    },
  },
}
</script>
<style lang="scss" scoped src="./style.scss"></style>
